@let commonData = commonDataService.getData() | async;

<div class="d-flex align-items-center justify-content-between px-4 pt-4 px-md-8 pt-md-8">
  <h1 class="semi-bold">Continue to your account</h1>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<p class="mt-2 mx-4 mx-md-8">
  Get better deals, save your details for easy booking, and see all your trips in one place.
</p>

<form [formGroup]="form" class="mt-8 mx-4 mx-md-8">
  <ds-input
    (focusin)="focus()"
    formControlName="email"
    [error]="form.errors ? activationError || undefined : undefined"
    label="Email"
    placeholder="Email"
    type="email"
    data-id="email"
  />

  <p *ngIf="form.errors" class="d-none" data-id="error">{{ activationError }}</p>
</form>

<div class="d-flex flex-column mt-4 mx-4 mx-md-8">
  <ds-button
    (click)="submit()"
    [disabled]="loading || form.invalid"
    label="Continue"
    [fullWidth]="true"
    data-id="send-email"
  />
</div>

<div class="mt-3 mx-4 mx-md-8 mb-4 mb-md-8">
  <p class="caption text-jazlyn-700">{{ commonData?.termsAgreement }}</p>
</div>
